import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  PAYMENT_LIST_ERROR,
  PAYMENT_LIST_LOADING,
  PAYMENT_LIST_RESET,
  PAYMENT_LIST_PAGINATION,
  PAYMENT_LIST_SUCCESS,
  PAYMENT_LIST_ORDER,
  PAYMENT_LIST_PAGE,
  PAYMENT_LIST_FILTER
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  items: [],
  pagination: [],
  filter: {},
  order: {
    field: 'createdAt',
    direction: 'asc'
  },
  currentPage: 1
};

function error(error) {
  return {type: PAYMENT_LIST_ERROR, error};
}

function loading(loading) {
  return {type: PAYMENT_LIST_LOADING, loading};
}

function success(items) {
  return {type: PAYMENT_LIST_SUCCESS, items};
}

function pagination(items) {
  return { type: PAYMENT_LIST_PAGINATION, items};
}

const getters = {
  error: state => state.error,
  items: state => state.items,
  loading: state => state.loading,
  pagination: state => state.pagination,
  order: state => state.order,
  filter: state => state.filter,
  currentPage: state => state.currentPage
};

const actions = {
    getItems: function({ commit, state }, page = '/payments') {
      commit(loading(true));
      commit(error(null));
      return http.fetch(page + '?' + http.buildQueryParams(state.currentPage, state.order, state.filter))
        .then(response => response.json())
        .then(data => {
          commit(loading(false));
          commit(success(data['hydra:member']));
          commit(pagination(data['hydra:pagination']));
        })
        .catch(e => {
          commit(loading(false));
          if(security.handleAuthorizationError(e)){
            return;
          }
          commit(error(e.message));
        });
    },
    order: function(context, column) {
      context.commit(PAYMENT_LIST_ORDER, column);
      context.dispatch('getItems');
    },
    filter: function(context, column) {
      context.commit(PAYMENT_LIST_FILTER, column);
      context.dispatch('getItems');
    },
    changePage: function(context, page) {
      context.commit(PAYMENT_LIST_PAGE, page);
      context.dispatch('getItems');
    }
};

const mutations = {
    [PAYMENT_LIST_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [PAYMENT_LIST_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [PAYMENT_LIST_PAGINATION] (state, payload) {
      state.pagination = payload.items;
    },
    [PAYMENT_LIST_SUCCESS] (state, payload) {
      state.items = payload.items;
    },
    [PAYMENT_LIST_RESET] (state) {
      state.items = [];
      state.currentPage = 1;
    },
    [PAYMENT_LIST_ORDER] (state, column) {
      if (state.order.field == column && state.order.direction !== 'desc') {
        state.order.direction = 'desc';
      }
      else if (state.order.field == column && state.order.direction == 'desc') {
        state.order.field = '';
      }
      else {
        state.order.direction = 'asc';
        state.order.field = column;
      }
    },
    [PAYMENT_LIST_PAGE] (state, page) {
       state.currentPage = page;
    },
    [PAYMENT_LIST_FILTER] (state, filter) {
      state.filter = filter;
    }

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/payment/list.js